export default defineNuxtPlugin(() => {
  // Handle title template to avoid "My Account | My Account" duplication
  useHead({
    titleTemplate: (titleChunk?: string) => {
      // If no specific title is provided, just return "My Account"
      if (!titleChunk || titleChunk === 'My Account') {
        return 'My Account'
      }
      // Otherwise, format as "Page Title | My Account"
      return `${titleChunk} | My Account`
    }
  })
})